"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseTagBoxLabelByCheckType = exports.getTagBoxColorByCheckType = exports.isCredentialValid = exports.getStatusDescription = exports.getStatusIcon = exports.getIssuerStatus = exports.findCredIndex = exports.formatDate = void 0;
const verified_icon_svg_1 = __importDefault(require("../../assets/images/icons/verified-icon.svg"));
const pending_icon_svg_1 = __importDefault(require("../../assets/images/icons/pending-icon.svg"));
const not_verified_icon_svg_1 = __importDefault(require("../../assets/images/icons/not-verified-icon.svg"));
const constants_1 = require("../../constants/constants");
const formatDate = (date, separator) => {
    const newDate = new Date(date);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    let dateArr = [day, month, year];
    return dateArr.join(separator);
};
exports.formatDate = formatDate;
const findCredIndex = (arr, cred) => {
    const index = arr.findIndex((item) => {
        if (item.velocityCredential && cred.velocityCredential) {
            return cred.velocityCredential.id === item.velocityCredential.id;
        }
        else if (item.sertifierCredential && cred.sertifierCredential) {
            return cred.sertifierCredential.id === item.sertifierCredential.id;
        }
        else {
            return false;
        }
    });
    return index;
};
exports.findCredIndex = findCredIndex;
const getIssuerStatus = (item) => {
    return constants_1.IssuerStatuses[item
        ? "velocityCredential" in item &&
            item.velocityCredential &&
            item.velocityCredential.recordStatus === 2
            ? 0
            : "offerExpirationDate" in item
                ? item.offerExpirationDate
                    ? new Date(item.offerExpirationDate) > new Date()
                        ? 1
                        : 0
                    : 1
                : item.expireDate
                    ? new Date(item.expireDate) > new Date()
                        ? 1
                        : 0
                    : 1
        : 1];
};
exports.getIssuerStatus = getIssuerStatus;
const getStatusIcon = (item) => {
    switch ((0, exports.getIssuerStatus)(item)) {
        case "verified":
            return verified_icon_svg_1.default;
        case "pending":
            return pending_icon_svg_1.default;
        default:
            return not_verified_icon_svg_1.default;
    }
};
exports.getStatusIcon = getStatusIcon;
const getStatusDescription = (item, translate, isWhitelabel) => {
    return item
        ? "velocityCredential" in item &&
            item.velocityCredential &&
            item.velocityCredential.recordStatus === 2
            ? translate("revoked")
            : "offerExpirationDate" in item
                ? item.offerExpirationDate
                    ? new Date(item.offerExpirationDate) > new Date()
                        ? translate("valid", {
                            expireDate: (0, exports.formatDate)(item.offerExpirationDate, "/"),
                        })
                        : translate("expired")
                    : translate(isWhitelabel ? "noExpireCredential" : "noExpire")
                : item.expireDate
                    ? new Date(item.expireDate) > new Date()
                        ? translate("valid", {
                            expireDate: (0, exports.formatDate)(item.expireDate, "/"),
                        })
                        : translate("expired")
                    : translate(isWhitelabel ? "noExpireCredential" : "noExpire")
        : "";
};
exports.getStatusDescription = getStatusDescription;
const isCredentialValid = (cred) => {
    return cred.expireDate
        ? new Date(cred.expireDate) > new Date()
            ? true
            : false
        : true;
};
exports.isCredentialValid = isCredentialValid;
const getTagBoxColorByCheckType = (checkType) => {
    if (checkType === "PASS") {
        return "green";
    }
    else if (checkType === "FAIL") {
        return "red";
    }
    return "yellow";
};
exports.getTagBoxColorByCheckType = getTagBoxColorByCheckType;
const getBaseTagBoxLabelByCheckType = (checkType, translate) => {
    if (checkType === "PASS") {
        return translate("yes").toString();
    }
    else if (checkType === "FAIL") {
        return translate("no").toString();
    }
    return "N/A";
};
exports.getBaseTagBoxLabelByCheckType = getBaseTagBoxLabelByCheckType;
